
interface ServiceCardProps {
  title: string;
  description: string;
  image: string;
  features: string[];
  href?: string;
}

export default function ServiceCard({ title, description, image, features, href = "#" }: ServiceCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title}
          title={`${title} - Servicios profesionales en Barcelona`}
          className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-800 mb-3">{title}</h3>
        <p className="text-gray-600 mb-4 leading-relaxed">{description}</p>
        
        <ul className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
              <i className="ri-check-line text-green-600 mt-0.5 flex-shrink-0"></i>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        
        <a 
          href={href}
          className="inline-flex items-center gap-2 text-green-600 font-semibold hover:text-green-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          Más información
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </div>
  );
}
